import { createSlice } from "@reduxjs/toolkit";
import { fetch } from "./reservations.service";

const ReservationsSlice = createSlice({
  name: "reservations",
  initialState: {
    reservationsCollection: [],
    isLoading: false,
    isError: false,
    errMsg: null,
    queryValue: null,
    filtersValue: {},
  },
  /* eslint-disable no-param-reassign */
  reducers: {
    setLoading(state) {
      state.isLoading = true;
      state.isError = false;
    },
    setProducts(state, action) {
      state.isLoading = false;
      const raw = action.payload.reservationsCollection;
      state.reservationsCollection = Array.isArray(raw) ? raw : [];
    },
    setError(state, action) {
      state.isError = true;
      state.errMsg = action.payload.errMsg;
    },
    setFilterValue(state, action) {
      const { key, value } = action.payload;
      state.filtersValue[key] = value;
    },
  },
  /* eslint-enable */
});

// Extract the action creators object and the reducer
const { actions, reducer } = ReservationsSlice;

// Extract and export each action creator by name
export const { setLoading, setProducts, setError, setFilterValue } = actions;

// Export the reducer, either as a default or named export
export default reducer;

function normalizeReservationsList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.reservations)) return data.reservations;
  if (data && Array.isArray(data.reservationsCollection))
    return data.reservationsCollection;
  return [];
}

export const fetchReservations = (companyId) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const data = await fetch(companyId);
    const reservationsCollection = normalizeReservationsList(data);
    dispatch(setProducts({ reservationsCollection }));
  } catch (e) {
    dispatch(setError(""));
  }
};
